// extracted by mini-css-extract-plugin
export default {"btn_prview":"style_btn_prview__jRKK7","downloadPdf":"style_downloadPdf__0hWH5"};